(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !window.DesignMode) return;
  try {
    
  class ViewportScroll extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.startValue = parseFloat(this.getAttribute('data-start')) || 0;
      this.endValue = parseFloat(this.getAttribute('data-end')) || 0;
      this.style.setProperty('--offset-length', `${this.startValue}px`);
      window.addEventListener('scroll', this.updateParallaxEffect.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateParallaxEffect.bind(this));
    }

    updateParallaxEffect() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const elementMiddle = rect.top + rect.height / 2;
      const progress = Math.min(
        Math.max((viewportHeight - elementMiddle) / viewportHeight, 0),
        1
      );
      const currentValue = this.startValue + progress * (this.endValue - this.startValue);
      const clampedValue = Math.max(
        Math.min(currentValue, Math.max(this.startValue, this.endValue)),
        Math.min(this.startValue, this.endValue)
      );
      this.style.setProperty('--offset-length', `${clampedValue}px`);
    }
  }
  if (!customElements.get('viewport-scroll')) { customElements.define('viewport-scroll', ViewportScroll);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !window.DesignMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
        
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();
})();
